import { CardModel } from "../../_shared/lottoloca-commom/lottery-modex";
import { ICollectionReference, IDocumentReference } from '../database-cast/IDatabase';


export class DbLotteryCardModel {
  

    _id: string;

    public getData(): Promise<CardModel> {

        let promise = new Promise<CardModel>((resolve) => {
            this._docReference.get()
                .then(snapshot => {

                    if(snapshot!= null && snapshot.data()!=null)
                    {
                    let cardModel:CardModel = Object.assign(snapshot.data());

                    cardModel.id = this._id;

                    resolve(cardModel);
                    }
                    else{
                    resolve(null);
                    }
                });
        });

        return promise;

    }

    public _docReference: IDocumentReference;

    constructor(id: string, colllection: ICollectionReference) {
        this._docReference = colllection.doc(id);
        this._id = id;
    }

    public delete(): Promise<void> {

        return this._docReference.delete();

    }

    public  update(value: CardModel): Promise<void> {
        
        let obj =JSON.parse( JSON.stringify(value));

        return this._docReference.set(obj);

      }

}